
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { NotificationsModule } from '~common-store/modules/notifications';

@Component
export default class TheNotifications extends Vue {
    get notificationsArray() {
        return NotificationsModule.notificationsArray;
    }

    // watch notifications array for any change in any item
    @Watch('notificationsArray', { deep: true })
    async showNotification(notificationsArray: []) {
        // when a change happens, check if there is remaining items in the array
        if (notificationsArray.length > 0) {
            // if there is at least one item, notify it
            this.$notify(NotificationsModule.notificationsArray[0]);
            // then remove it from the array
            await NotificationsModule.shiftNotification();
        }
    }
}
